import { Component, Output, EventEmitter, Input, OnInit } from '@angular/core';
import { Platform } from '@angular/cdk/platform';

import { Facs, Badges, Favorite, SendOpenModal } from 'src/app/core/models/facs.model';

@Component({
  selector: 'app-dnd-card',
  templateUrl: './dnd-card.component.html',
  styleUrls: ['./dnd-card.component.scss']
})
export class DndCardComponent implements OnInit {

  @Output() public sendDrag = new EventEmitter<boolean>();
  @Output() public sendFavorite = new EventEmitter<Favorite>();
  @Output() public openModal = new EventEmitter<SendOpenModal>();
  @Input() public item: Facs;
  @Input() public feature = true;
  @Input() public isLeader;

  public iconStand: Badges;
  public iconCorp: Badges;
  public iconProduct: Badges;

  public cursors = false;
  public isMobile = false;

  constructor(public platform: Platform) {}

  ngOnInit() {
    this.mobile();
    this.getHours();
  }

  public mobile() {
    if (this.platform.ANDROID || this.platform.IOS) {
      this.isMobile = true;
    }
  }

  public getHours() {
    for (const key in this.item) {
      if (this.item.hasOwnProperty(key)) {
        this.initTime(key, this.item[key]);
      }
    }
  }

  private initTime(key, hora) {
    switch (key) {
      case 'last_update_date':
        this.item.last_update_date = hora;
        break;
      case 'contact':
        this.item.contact = hora;
        break;
      case 'visit_date':
        this.item.visit_date = hora;
        break;
    }
  }

  public selectFav() {
    this.item.is_favorite = !this.item.is_favorite;
    this.sendFavorite.emit({
      id: this.item.id,
      is_favorite: this.item.is_favorite
    });
  }

  public sendOpenModal(event, flag: boolean) {
    event.stopPropagation();
    if (flag) {
      this.openModal.emit({ id: this.item.id, openModal: flag});
    } else {
      return false;
    }
  }

  public dragAction() {
    this.sendDrag.emit(false);
    this.cursors = true;
  }

}
